import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  alpha,
} from '@mui/material';
import { ExpandMore, Storage } from '@mui/icons-material';
import { FaNodeJs } from "react-icons/fa";
import BaseTab from './BaseTab';

interface BackendInstallationTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const BackendInstallationTab: React.FC<BackendInstallationTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Backend Installation"
      emoji="🔧"
    >
      <Typography variant="h6" sx={{ color: props.goldColor, mb: 3 }}>
        Backend Setup Guide
      </Typography>

      <Paper sx={{ bgcolor: alpha('#051814', 0.8), p: 3, borderRadius: 2, mb: 3 }}>
        <Typography variant="h6" sx={{ color: props.goldColor, mb: 2 }}>
          Prerequisites
        </Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FaNodeJs size={30} color={props.goldColor} />
              <Typography variant="body2" color={props.colors.textPrimary}>
                Node.js (v16 or higher)
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Storage sx={{ color: props.goldColor }} />
              <Typography variant="body2" color={props.colors.textPrimary}>
                MongoDB (local or cloud)
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Accordion defaultExpanded sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMore sx={{ color: props.goldColor }} />}>
          <Typography fontWeight={700} color={props.colors.textPrimary}>
            Step 1: Clone & Install
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper sx={{ bgcolor: '#1E1F22', p: 2, borderRadius: 1 }}>
            <Typography variant="body2" fontFamily="monospace" color={props.goldColor}>
              git clone https://github.com/Kaiftokare19/WFHCafeDev-Backend.git<br />
              cd wfhcafe-backend<br />
              npm install
            </Typography>
          </Paper>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMore sx={{ color: props.goldColor }} />}>
          <Typography fontWeight={700} color={props.colors.textPrimary}>
            Step 2: Environment Setup
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper sx={{ bgcolor: '#1E1F22', p: 2, borderRadius: 1 }}>
            <Typography variant="body2" fontFamily="monospace" color={props.goldColor}>
              # Create .env file<br />
              MONGODB_URI=mongodb://localhost:27017/wfhcafe<br />
              JWT_SECRET=your-super-secret-jwt-key<br />
              GOOGLE_CLIENT_ID=your-google-client-id<br />
              GOOGLE_CLIENT_SECRET=your-google-client-secret<br />
              GOOGLE_MAPS_API_KEY=your-google-maps-api-key<br />
              PINATA_JWT=your-pinata-jwt<br />
              PORT=3000
            </Typography>
          </Paper>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ mb: 2 }}>
        <AccordionSummary expandIcon={<ExpandMore sx={{ color: props.goldColor }} />}>
          <Typography fontWeight={700} color={props.colors.textPrimary}>
            Step 3: Build & Run
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper sx={{ bgcolor: '#1E1F22', p: 2, borderRadius: 1 }}>
            <Typography variant="body2" fontFamily="monospace" color={props.goldColor}>
              # Build the application<br />
              npm run build<br /><br />
              
              # Start the server<br />
              npm run dev  # Development mode<br />
              npm start    # Production mode
            </Typography>
          </Paper>
        </AccordionDetails>
      </Accordion>
    </BaseTab>
  );
};

export default BackendInstallationTab;